<template>
    <div class="index">
        <div class="loading" :class="{hide: isHideLoading}">
            <p class="progress">{{loadingAniNumber}}%</p>
            <p>loading...</p>
        </div>
        <!-- banner -->
        <Banner :data="indexData.banner"/>
        <!-- info -->
        <Info :data="indexData"/>
        <!-- video -->
        <div class="video" id="brand">
            <div class="cover">
                <img class="pc" :src="indexData.index_video.image" alt=""/>
                <img class="mobile" :src="indexData.index_video.web_image" alt=""/>
                <div class="play" @click="showVideo"><span>观看视频</span></div>
            </div>
            <div class="text">
                <p class="text1">{{indexData.index_video.title}}</p>
                <p class="text2">{{indexData.index_video.title_en}}</p>
                <div class="play"><div class="btn" @click="showVideo"><span>观看视频</span></div></div>
            </div>
        </div>
        <div class="popup" :class="{active: isShowVideo}">
            <!-- <div class="close" @click="hideVideo"></div> -->
            <div class="btn_close" @click="hideVideo"></div>
            <div class="in">
                <video ref="video" :src="indexData.index_video.video" controls></video>
            </div>
        </div>
        <!-- new -->
        <div class="container" id="sustainable">
            <div class="news">
                <div class="new_inner">
                    <div class="cover" :style="`background-image: url(${indexData.development_concept.image});`"></div>
                    <div class="text">
                        <div class="title">{{indexData.development_concept.name}}</div>
                        <div class="desc">{{indexData.development_concept.desc}}</div>
                        <div class="more"><a :href="indexData.development_concept.url" target="_blank">了解更多&gt;</a></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- introduction -->
        <div class="introduction_wrap" id="companyProfile">
            <div class="container">
                <div class="introduction" v-if="indexData.shuion_desc.length > 0">
                    <div class="tab">
                        <div class="item" 
                        v-for="(item, index) in indexData.shuion_desc" :key="index"
                        :class="{active: introductionActiveIndex == index}"
                        @click="introductionActiveIndex = index">
                            <p class="title">{{item.name}}</p>
                            <div class="line"></div>
                            <p class="title_en">{{item.name_en}}</p>
                        </div>
                    </div>
                    <div class="content">
                        <div class="desc">
                            <img class="logo" :src="indexData.shuion_desc[introductionActiveIndex].logo" alt=""/>
                            <p class="text" v-html="textToHtml(indexData.shuion_desc[introductionActiveIndex].desc)"></p>
                        </div>
                        <!-- <img class="cover" :src="indexData.shuion_desc[introductionActiveIndex].image" alt=""/> -->
                        <div class="cover" :style="`background-image: url(${indexData.shuion_desc[introductionActiveIndex].image})`"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Banner from '../components/index/banner.vue';
import Info from '../components/index/info.vue';
import lineBreaks from '../utils/lineBreaks';
export default {
    name: "index",
    data() {
        return {
            isShowVideo: false,
            introductionActiveIndex: 0,
            loadingAniNumber: 0,
            isHideLoading: false,
        };
    },
    computed: {
        ...mapState([ 'indexData' ]),
        textToHtml: lineBreaks.textToHtml,
    },
    components: {
        Info,
        Banner,
        
    },
    mounted() {
        this.$store.dispatch('getHomeData');
        this.loadingAniInit();
    },
    destroyed() {},
    watch: {},
    methods: {
        loadingAniInit(){
            document.body.style.overflow = 'hidden';
            let self = this;
            let loadingAni = setInterval(()=>{
                self.loadingAniNumber++;
                if(self.loadingAniNumber == 100){
                    clearInterval(loadingAni);
                    self.isHideLoading = true;
                    document.body.style.overflow = '';
                }
            }, 1000 / 100)
        },
        showVideo(){
            document.body.style.overflow = 'hidden';
            this.isShowVideo = true;
            this.$nextTick(()=>{
                this.$refs.video.currentTime = 0;
                this.$refs.video.play();
            })
        },
        hideVideo(){
            document.body.style.overflow = '';
            this.$refs.video.pause();
            this.isShowVideo = false;
        }
    },
};
</script>

<style scoped lang="scss">
.loading{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: .3rem;
    z-index: 999;
    transition: opacity .5s, visibility .5s;
    &.hide{
        opacity: 0;
        visibility: hidden;
    }
    .progress{
        width: 4rem;
        height: 3.7rem;
        background: url('~@/assets/images/page_loading.png') no-repeat 0/100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .46rem;
        margin-bottom: 1rem;
    }
    @media only screen and (max-width: 1200px) {
        font-size: .48rem;
        .progress{
            width: 10.46rem;
            height: 9.68rem;
            font-size: .98rem;
            margin-bottom: 4.5rem;
        }
    }
}
.video{
    position: relative;
    img{
        width: 100%;
    }
    .cover{
        .mobile, .play{ display: none; }
    }
    .text{
        position: absolute;
        left: 38.54%;
        top: 2rem;
        transform: translate(-50%, 0);
        text-align: center;
        font-weight: bold;
        line-height: 1.8;
        display: block;
        .text1{
            font-size: .48rem;
        }
        .text2{
            font-size: .36rem;
        }
        .play{
            display: flex;
            justify-content: center;
            text-decoration: underline;
            .btn{
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                &::before{
                    content: "";
                    display: block;
                    width: .22rem;
                    height: .22rem;
                    margin-right: .08rem;
                    background: url('~@/assets/images/icon_play.png') no-repeat 0/100%;
                }
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        display: flex;
        flex-direction: column-reverse;
        .cover{
            position: relative;
            .pc{ display: none; }
            .mobile{ display: block; }
            .play{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                color: #fff;
                font-size: .3rem;
                &::before{
                    content: "";
                    display: block;
                    width: 2.2rem;
                    height: 2.2rem;
                    background: url('~@/assets/images/icon_play2.png') no-repeat 0/100%;
                    margin-bottom: 1rem;
                }
                span{
                    border-bottom: 1px solid #fff;
                }
            }
        }
        .text{
            position: relative;
            left: 0;
            top: 0;
            transform: none;
            padding: 1.2rem 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-weight: normal;
            .text1{
                font-size: .72rem;
            }
            .text2{
                font-size: .48rem;
            }
            .play{
                display: none;
            }
        }
    }
}
.popup{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .5);
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transition: opacity .5s, visibility .5s;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active{
        opacity: 1;
        visibility: visible;
    }
    .close{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .btn_close{
        position: absolute;
        top: .3rem;
        right: .3rem;
        width: .5rem;
        height: .5rem;
        border: 2px solid #fff;
        border-radius: 50%;
        background: rgba($color: #000, $alpha: .3);
        z-index: 1;
        cursor: pointer;
        @media only screen and (max-width: 1200px) {
            width: 1rem;
            height: 1rem;
        }
        &::before,
        &::after{
            width: 60%;
            height: 2px;
            background: #fff;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
        }
        &::before{
            transform: translate(-50%, -50%) rotate(-45deg);
        }
    }
    .in{
        width: 100%;
        height: 100%;
        video{
            width: 100%;
            height: 100%;
            background: #000;
            display: block;
        }
    }
}
.news{
    display: flex;
    flex-direction: row-reverse;
    padding: .8rem 0;
    .new_inner{
        width: 8.7rem;
        background: #e5e5e5;
        padding: .3rem 0;
        display: flex;
        .cover{
            margin-left: -3.3rem;
            width: 5.35rem;
            height: 3.58rem;
            background: no-repeat center/cover;
            border-radius: .04rem;
        }
        .text{
            flex: 1;
            padding: .4rem .5rem 0;
            .title{
                font-size: .26rem;
                text-align: center;
                margin-bottom: .2rem;
            }
            .desc{
                line-height: 1.8;
                text-align: justify;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 8;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
            }
            .more{
                text-align: right;
                a:hover{
                    color: #ff4a32;
                    border-bottom: 1px solid #ff4a32;
                }
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        padding: 0;
        padding-bottom: 1.2rem;
        flex-direction: column;
        .new_inner{
            width: 100%;
            flex-direction: column-reverse;
            background: none;
            padding: 0;
            .cover{
                width: 100%;
                height: 8.4rem;
                margin: 0;
            }
            .text{
                padding: 1.2rem 1rem;
                .title{
                    font-size: .72rem;
                    margin-bottom: .5rem;
                }
                .desc{
                    font-size: .36rem;
                    -webkit-line-clamp: 4;
                }
                .more{
                    text-align: center;
                    margin-top: .5rem;
                    a{
                        border-bottom: 1px solid #000;
                    }
                }
            }
        }
    }
}
.introduction_wrap{
    background: #e6e6e6;
    @media only screen and (max-width: 1200px) {
        background: none;
    }
}
.introduction{
    padding-bottom: .5rem;
    .tab{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: .6rem 0;
        .item{
            // width: 1.7rem;
            margin: 0 .45rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            &.active{
                color: #ff4a32;
                .line{
                    background: #ff4a32;
                }
                .title{
                    font-weight: bold;
                }
            }
            .title{
                font-size: .26rem;
                // font-weight: bold;
                letter-spacing: .15em;
            }
            .line{
                width: 100%;
                // width: 1.65rem;
                height: 1px;
                margin: .1rem 0;
            }
        }
    }
    .content{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .desc{
            width: 5.1rem;
            line-height: 1.8;
            text-align: justify;
            .logo{
                width: 1.5rem;
                margin: 0 auto .2rem;
            }
        }
        .cover{
            width: 5.48rem;
            height: 3.12rem;
            background: no-repeat center/cover;
        }
    }
    @media only screen and (max-width: 1200px) {
        padding-bottom: 0;
        .tab{
            padding: 0;
            .item{
                flex: 1;
                margin: 0;
                height: 2rem;
                border-radius: 0 .2rem 0 0;
                line-height: 1;
                &:nth-of-type(2){
                    border-radius: .2rem 0 0 0;
                }
                &.active{
                    background: #e5e5e5;
                    .line{
                        margin: .2rem 0;
                    }
                }
                .line{
                    width: 3rem;
                }
                .title{
                    font-weight: normal;
                    font-size: .48rem;
                }
                .title_en{
                    font-size: .3rem;
                }
            }
        }
        .content{
            flex-direction: column-reverse;
            .cover{
                width: 100%;
                height: 8.94rem;
            }
            .desc{
                width: 100%;
                padding: 1rem;
                .logo{
                    width: 3rem;
                    margin-bottom: .6rem;
                }
            }
        }
    }
}
</style>